import {
  AuthenticateQueryParams,
  AuthenticateResponse,
  CardApplicationResponse,
  CbsTokenResponse,
  ConfigResponse,
  CreditLimitApplicationRequest,
  FileIdPathParam,
  GetConfigQueryParams,
  GetFileDownloadUrlResponse,
  GetFileStatusResponse,
  LogErrorRequest,
  PaymentCardApplicationRequest,
  SendApplicationRequest,
  SignApplicationResponse,
  StatusResponse,
  ValidatePhoneNumberRequest,
  ValidatePhoneNumberResponse,
  VerifyAuthCodeRequest,
  VerifyAuthCodeResponse,
} from './types'

export interface Endpoint<TResponse = void, TRequest = void, TQueryParamNames = never, TPathParamNames = never> {
  path: string
  method: 'get' | 'put' | 'post' | 'delete'
  responsePayload?: TResponse
  requestPayload?: TRequest
  queryParamNames?: TQueryParamNames
  pathParamNames?: TPathParamNames
}

export const ENDPOINT_NEW_CARD_APPLICATION: Endpoint<void, PaymentCardApplicationRequest> = {
  path: '/application/new-card',
  method: 'put',
}

export const ENDPOINT_CREDIT_LIMIT_APPLICATION: Endpoint<void, CreditLimitApplicationRequest> = {
  path: '/application/credit-limit',
  method: 'put',
}

export const ENDPOINT_PREVIEW_APPLICATION: Endpoint<string> = {
  path: '/application/preview',
  method: 'get',
}

export const ENDPOINT_SIGN_APPLICATION: Endpoint<SignApplicationResponse> = {
  path: '/application/signing-url',
  method: 'get',
}

export const ENDPOINT_SEND_APPLICATION: Endpoint<CardApplicationResponse, SendApplicationRequest> = {
  path: '/application/send',
  method: 'put',
}

export const ENDPOINT_AUTHENTICATE: Endpoint<AuthenticateResponse, void, AuthenticateQueryParams> = {
  path: '/authenticate',
  method: 'get',
}

export const ENDPOINT_VERIFY_AUTH_CODE: Endpoint<VerifyAuthCodeResponse, VerifyAuthCodeRequest> = {
  path: '/verify-auth-code',
  method: 'post',
}

export const ENDPOINT_LOG_ERROR: Endpoint<void, LogErrorRequest> = {
  path: '/log-error',
  method: 'post',
}

export const ENDPOINT_GET_CONFIG: Endpoint<ConfigResponse<string>, void, GetConfigQueryParams<string, string>> = {
  path: '/config',
  method: 'get',
}

export const ENDPOINT_GET_CBS_TOKEN: Endpoint<CbsTokenResponse> = {
  path: '/cbs-token',
  method: 'get',
}

export const ENDPOINT_STATUS: Endpoint<StatusResponse> = {
  path: '/status',
  method: 'get',
}

export const ENDPOINT_VALIDATE_PHONE_NUMBER: Endpoint<ValidatePhoneNumberResponse, ValidatePhoneNumberRequest> = {
  path: '/validate-phone-number',
  method: 'post',
}

export const ENDPOINT_GET_FILE_STATUS: Endpoint<GetFileStatusResponse, void, never, FileIdPathParam> = {
  path: '/file/{fileId}/status',
  method: 'get',
}

export const ENDPOINT_DELETE_FILE: Endpoint<void, void, never, FileIdPathParam> = {
  path: '/file/{fileId}',
  method: 'delete',
}

export const ENDPOINT_GET_FILE: Endpoint<GetFileDownloadUrlResponse, void, never, FileIdPathParam> = {
  path: '/file/{fileId}',
  method: 'get',
}

export const ENDPOINT_LOGOUT: Endpoint = {
  path: '/logout',
  method: 'post',
}
